import React from 'react'

import {
  ProfileButton,
  ProfileMenuBlock,
  ProfileTitle,
} from './ProfileComponents.tsx'
import { FormattedMessage } from 'react-intl'
import { recurrentTermsUrl, termsUrl } from '../auth/login.tsx'

export const ProfileAbout = () => {
  const links = [
    {
      title: <FormattedMessage id="user.terms" />,
      url: recurrentTermsUrl,
    },
    {
      title: <FormattedMessage id="user.privacyPolicy" />,
      url: termsUrl,
    },
  ]

  return (
    <div>
      <ProfileTitle title={<FormattedMessage id="user.aboutUs" />} />
      <div className="flex flex-col gap-16">
        {links.map((x, i) => {
          return (
            <ProfileMenuBlock key={i}>
              <ProfileButton
                withArrow
                onClick={() => {
                  window.open(x.url, '_blank')
                }}
                title={x.title}
              />
            </ProfileMenuBlock>
          )
        })}
      </div>
    </div>
  )
}
